import type { TelephonicEntryDetailsType } from '../../../services/commonCheckout/types/CheckoutSessionsResponse';

export const getTelephonicEntryUrlDetails = (
  telephonicEntryDetails: TelephonicEntryDetailsType | undefined,
) => {
  if (
    !telephonicEntryDetails ||
    telephonicEntryDetails.status !== 'IN_PROGRESS' ||
    !('url' in telephonicEntryDetails)
  ) {
    return {
      sycurioHttpOrigin: undefined,
      sycurioFragmentUrl: undefined,
    };
  }

  const sycurioUrl = new URL(telephonicEntryDetails.url);

  return {
    sycurioHttpOrigin: sycurioUrl.origin,
    sycurioFragmentUrl: sycurioUrl.href,
  };
};
